import React, { useState, useEffect } from "react";

import TemplateGrid from "./components/TemplateGrid/TemplateGrid";
import TemplateHeader from "./components/TemplateHeader/TemplateHeader";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import CompletedView from "./components/CompletedView/CompletedView";
import AssignedView from "./components/AssignedView/AssignedView";
import ArchiveView from "./components/ArchiveView/ArchiveView";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { useNavigate } from "react-router-dom";
import Loading from "Components/loading";
import { validateMagicLink } from "Helpers/call_apis";

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		minHeight: "90vh",
	},
	explorerContainer: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		overflowY: "auto",
		backgroundColor: "#f0f0f0",
		flex: 1,
		height: "100%",
	},
}));
const theme = createMuiTheme({
	palette: {
		primary: {
			main: "#006ac6",
		},
		secondary: {
			main: "#009A17",
		},
		green: {
			main: "#009A17",
		},
	},
	typography: {
		fontFamily: ["Roboto", "Helvetica", "sans-serif"].join(","),
	},
});
const DocForms = () => {
	const classes = useStyles();
	const [startPage] = useState(true);
	const dispatch = useDispatch();
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(50);
	const [valueSearch, setValueSearch] = useState("");
	const navigate = useNavigate();
	const notify = (msj, event) => toast[event](msj);
	const [loading, setLoading] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState("Processing...");

	const [mpage, setMPage] = useState(0);
	const [tabValue, setTabValue] = React.useState(0);

	const handleTabChange = (newValue) => {
		setTabValue(newValue);
	};

	useEffect(() => {
		if (startPage) {
			// getSearchFile(true);

			const params = new URLSearchParams(window.location.search);
			const token = params.get("token");
			if (token) {
				// Handle the token as needed, e.g., store it in state or use it for authentication
				
				// Validate the magic link token
				setLoadingPage(true, "Validating magic link...");
				validateMagicLink(token)
					.then((response) => {
						if (response && response.data?.is_valid === true) {
				

							console.log("response validateMagicLink", response);
							const displayName =
								response.data?.user_name ||
								response.data?.user_email?.split("@")?.[0] ||
								"";
							// Set up localStorage with user data for automatic login
							const userData = {
								approvalProcess: response.approvalProcess || 0,
								companyName: response.companyName || null,
								customerId: response.customerId || "",
								email: response.data.user_email,
								fullName: displayName,
								name: displayName,
								displayName,
								lastLogin: response.lastLogin || null,
								mfaId: response.mfaId || null,
								mfaRequired: response.mfaRequired || false,
								plan: response.plan || null,
								productType: response.productType || null,
								superUser: response.superUser || 0,
								token: token,
								userId: response.data?.user_id || response.userId,
								userName: response.data?.user_name || response.userName,
								isMagicLink: true // Indicate that this user was authenticated via magic link
							};
							console.log("response", response);
							localStorage.setItem("esignature", JSON.stringify(userData));
							console.log("Magic link", response.data?.has_been_used);
							if (response.data?.has_been_used == false) {
								notify("Magic link validated successfully!", "success");
								navigate(`/docFormFiller/${response.data.template_id}/${response.data.form_request_id}`);
								setTabValue(1); // This will re-render AssignedView
								setTabValue(0); // This will re-render CompletedView
							} else {
								console.error("Magic link has already been used", "warning");
								notify("Form request has already been filled", "info");
								setTabValue(0); // This will re-render AssignedView
								setTabValue(1); // This will re-render CompletedView
							}

						} else {
							console.error("Magic link has expired", response);
							notify("Invalid or expired magic link", "error");
							setTimeout(() => {
								navigate("/");
							}, 3000);
						}
						// Navigate to home page after successful authentication

					})
					.catch((error) => {
						console.error("Magic link validation failed:", error);
						notify("Invalid or expired magic link", "error");
						// Handle validation failure
						setTimeout(() => {
							navigate("/");
						}, 3000);
					})
					.finally(() => {
						setLoadingPage(false);
					});
			} else {
				console.log("No token found in URL");
			}
		}
	}, [startPage]);
	const setLoadingPage = (loading, message = "Processing...") => {
		setLoading(loading);
		setLoadingMessage(message);
	};
	return (
		<div>
			<Loading show={loading} text={loadingMessage} />
			<ThemeProvider theme={theme}>
				<div className={classes.container}>
					<TemplateHeader tabValue={tabValue} onTabChange={handleTabChange} />

					<div className={classes.explorerContainer}>
						{/* {tabValue === 0 && (
						<TemplateGrid
							setLoading={setLoadingPage}
							reloadTemplates={() => {}}
						/>
					)} */}
						{tabValue === 0 && <AssignedView setLoading={setLoadingPage} />}
						{tabValue === 1 && <CompletedView setLoading={setLoadingPage} />}
						{/* {tabValue === 3 && <ArchiveView setLoading={setLoadingPage} />} */}
					</div>
					<ToastContainer autoClose={3000} />
				</div>
			</ThemeProvider>
		</div>
	);
};

export default DocForms;
